export enum EPerMode {
    PerCycle = 0,
    PerCampaign = 1,
    PerCompany = 2
}